export default class StatisticFileBinding {
  constructor({ datePicker, formattedStartDate, startDate, type }) {
    this.datePicker = datePicker;
    this.formattedStartDate = formattedStartDate;
    this.startDate = startDate;
    this.type = type;
  }
}
